import React, { useState, useEffect, useRef } from "react";
import { fetchSearchQuery } from "../utils/chatApi";
// import "./SearchBar.css";

export const SearchBar: React.FC = () => {
  const [query, setQuery] = useState("");
  const [answer, setAnswer] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [showAnswer, setShowAnswer] = useState(true);
  const panelRef = useRef<HTMLDivElement>(null);
  const searchBarRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const panel = panelRef.current;
    if (!panel) return;
    ["mousedown", "touchstart", "dblclick", "mousewheel"].forEach((evt) =>
      panel.addEventListener(evt, (e) => e.stopPropagation())
    );
    return () => {
      ["mousedown", "touchstart", "dblclick", "mousewheel"].forEach((evt) =>
        panel.removeEventListener(evt, (e) => e.stopPropagation())
      );
    };
  }, [answer]);

  // Position the search bar to the right of the sidebar
  useEffect(() => {
    const sidebarElement = document.getElementById("sidebar");
    const sidebarWidth = sidebarElement?.getBoundingClientRect().width || 0;
    if (searchBarRef.current) {
      searchBarRef.current.style.left = `${sidebarWidth + 65}px`;
      if (window.innerWidth <= 680) {
        searchBarRef.current.style.cssText += `display: none !important;`;
      }
      //  searchBarRef.current.style.width = `${sidebarWidth + 65}px`;
    }
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setAnswer(null);
    setShowAnswer(true);

    try {
      const result = await fetchSearchQuery(query);
      setAnswer(result);
    } catch (err: any) {
      console.error(err);
      setError(err.message || "Unknown error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="search-bar-container" ref={searchBarRef}>
      <form onSubmit={handleSubmit} className="search-form">
        <input
          id="querybox"
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Ask ChatGPT..."
          className="search-input"
          disabled={loading}
          required
        />
        <button
          id="askbtn"
          type="submit"
          className="search-button"
          disabled={loading}
          onPointerDown={(e) => e.stopPropagation()}
        >
          {loading ? "Waiting…" : "Ask"}
        </button>
        {answer && (
          <button
            id="showanswerbtn"
            type="button"
            className="toggle-button"
            onClick={() => setShowAnswer((prev) => !prev)}
          >
            {showAnswer ? "Hide Answer" : "Show Answer"}
          </button>
        )}
      </form>

      {error && <div className="error-text">Error: {error}</div>}

      {answer && showAnswer && (
        <div ref={panelRef} className="answer-panel">
          <h3>Answer:</h3>
          <p>{answer}</p>
        </div>
      )}
    </div>
  );
};
